import styled from "styled-components";
import { Heading6 } from "../../../../components";

export const FiltersPanelContainer = styled.div`
  & ${Heading6} {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
  }
`;
